module.exports = __webpack_public_path__ + "static/media/mana_bar_blue.ae59477e.png";